import { msg } from 'gt-react';
import { Action, Subject } from '@erp/authz';
import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { z } from 'zod';
import {
  Route as pathlessAuthenticatedRoute,
  requirePermission,
} from '../route';

const AgentMonitorListingPage = lazyRouteComponent(
  () => import('./AgentMonitorListingPage'),
  'AgentMonitorListingPage',
);

export const Route = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/agent-monitor',
  staticData: {
    app: {
      // No `nav` — Agent Monitor stays reachable by URL and quick search, but
      // it is not a sidebar item.
      access: {
        permissionsAnyOf: [
          { action: Action.Read, subject: Subject.BackgroundAgent },
        ],
      },
    },
  },
  component: AgentMonitorListingPage,
  loader: () => ({
    crumb: msg('Agent Monitor', { context: 'page breadcrumb' }),
  }),
  beforeLoad: async ({ context }) => {
    await requirePermission({
      context,
      action: Action.Read,
      subject: Subject.BackgroundAgent,
    });
  },
  validateSearch: z.object({}),
});
